import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { parseLegacySignupParams, type LegacySignupParams } from '../services/legacy-params';
import { useSignupFlowStore } from '../stores/signup-flow-store';

/**
 * Read the legacy params from the current URL and hold them for the flow.
 * Runs on every flow page, so a reload on a later step refills the store from
 * that step's own URL. Must render under a Suspense boundary (Next's
 * `useSearchParams` contract for a statically exported page).
 */
export function useLegacySignupParams(): LegacySignupParams {
  const search = useSearchParams().toString();
  const params = useMemo(() => parseLegacySignupParams(search), [search]);
  const setParams = useSignupFlowStore((state) => state.setParams);
  useEffect(() => {
    setParams(params);
  }, [params, setParams]);
  return params;
}
